import { useState } from 'react';
import PropTypes from 'prop-types';

import './DonateModal.css';
import btc from '../../../assets/btc.png';
import eth from '../../../assets/eth.png';

import { buildClass } from '../../../libs/classes';
import ModalBase from '../ModalBase';

const donateModalStyles = {
	content: {
		maxWidth: '450px',
		minWidth: '320px',
	},
};

const CONTACT_EMAIL = 'artem.pavlov@gmail.com';

/**
 * Donation (support the project) modal window
 * @component
 */
const DonateModal = ({ isOpen, onRequestClose }) => {
	const [selected, setSelected] = useState('');

	const handleSelectCrypto = (selected_upd) => {
		if (selected !== selected_upd) {
			setSelected(selected_upd);
		}
		//console.log('selected: ', selected_upd)
	};
	const handleRequestClose = () => {
		setSelected('');
		onRequestClose?.();
	};

	return (
		<ModalBase
			className="modal-donate"
			isOpen={isOpen}
			style={donateModalStyles}
			onRequestClose={handleRequestClose}
		>
			<div className="modal-header">
				<div className="modal-title">Contribute at MTG Keeper project</div>
				<div className="modal-close-x" onClick={handleRequestClose} />
			</div>
			<div className="modal-content">
				<div className="block">
					<div className="line">Donate to our hosting to keep the project working</div>
					<div className="line hosting">
						<span className="payment-icons">
							<a href="https://ruvds.com/en-usd/pay/aa1b0fb3be164d71b215a146bff0408a">
								<span className="vs" />
								Visa
							</a>
							<a href="https://ruvds.com/en-usd/pay/aa1b0fb3be164d71b215a146bff0408a">
								<span className="mc" />
								MasterCard
							</a>
							<a href="https://ruvds.com/en-usd/pay/aa1b0fb3be164d71b215a146bff0408a">
								<span className="pp" />
								PayPal
							</a>
						</span>
					</div>
				</div>
				<div className="block">
					<div className="line">Donate directly to help us improve the project:</div>
					<div className="line direct">
						<div className="crypto-icons">
							<span
								className={buildClass('link').add(selected === 'btc', 'selected')}
								onClick={() => {
									handleSelectCrypto('btc');
								}}
							>
								<img alt="BTC icon" src={btc} /> BTC
							</span>
							<span
								className={buildClass('link').add(selected === 'eth', 'selected')}
								onClick={() => {
									handleSelectCrypto('eth');
								}}
							>
								<img alt="ETH icon" src={eth} /> ETH
							</span>
						</div>
						<div className="wallet">
							{selected === 'btc' ? (
								<div>
									<div className="qr-code btc" />
									<div className="name">BTC wallet</div>
									<div className="number btc">1FLQA64jhk5hYkYPcvA91GqD4q9ppAD8gQ</div>
									<div className="email">
										You can email about transaction for record in hall of donators and my personal
										thanks: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
									</div>
								</div>
							) : null}
							{selected === 'eth' ? (
								<div>
									<div className="qr-code eth" />
									<div className="name">ETH wallet</div>
									<div className="number eth">0x6c178487a701b8B28e43e743f564F0f4f7Fc4Ad3</div>
									<div className="email">
										You can email about transaction for record in hall of donators and my personal
										thanks: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
									</div>
								</div>
							) : null}
						</div>
					</div>
				</div>
				<div className="block">And above all, use MTG Keeper and recommend it to anyone who may need it!</div>
				<div className="block thanks">A huge thanks to every one of you!</div>
			</div>
		</ModalBase>
	);
};

DonateModal.propTypes = {
	// Open state
	isOpen: PropTypes.bool.isRequired,
	// Callback on close dialog request
	onRequestClose: PropTypes.func,
};

export default DonateModal;
